import React, { Component } from 'react'
import { LoadScript } from '@react-google-maps/api'

import { config } from '../config'
import { Outlet } from 'react-router'

class Layout extends Component {
  render() {
    return (
      <div>
        <LoadScript googleMapsApiKey={config.googleMapsApiKey} version={3}>
          <Outlet />
        </LoadScript>
      </div>
    )
  }
}

export default Layout
